import { Image, Modal, Typography } from '@smartgift/frontend-toolkit';
import React from 'react';
import { useTranslation } from 'react-i18next';

import * as S from './style';

function MoreInformationModal({ isModalOpen, onRequestClose, contentList }) {
  const { t } = useTranslation();

  return (
    <Modal isOpen={isModalOpen} onRequestClose={onRequestClose} title={t('moreInformation')}>
      {contentList?.map(item => (
        <S.Item key={item.title}>
          {item.icon}
          <Typography variant="body2Bold" style={{ marginBottom: '4px' }}>
            {item.title}
          </Typography>
          <Typography variant="body2" style={{ marginBottom: '12px' }}>
            {item.description}
          </Typography>
          {item.images?.map((image, index) => (
            <Image key={index.toString()} src={image.src} alt={image.alt} />
          ))}
        </S.Item>
      ))}
    </Modal>
  );
}

export { MoreInformationModal };
